import { Theme } from '@benzinga/themetron';
import { TickerCardQuote } from '../TickerCard';
import { UseTickerDataResult } from './useTickerData';

interface IGetColor {
  theme: Theme;
  value?: number;
  variant?: string;
}

export const getTextColor = ({ theme, value, variant }: IGetColor): React.CSSProperties['color'] => {
  if (variant === 'light') {
    if (value) {
      return value >= 0 ? theme.colorPalette.green500 : theme.colorPalette.red500;
    }
    return theme.colors.foregroundMuted;
  }
  if (variant === 'article') {
    return;
  }
  return theme.colors.foreground;
};

export const getBgColor = ({ theme, value, variant }: IGetColor): React.CSSProperties['background'] => {
  if (variant === 'light') {
    if (value) {
      return value >= 0 ? theme.colorPalette.green200 : theme.colorPalette.red200;
    }
    return theme.colorPalette.gray100;
  }
  return theme.colorPalette.white;
};

export const convertSymbolToURLFriendly = (symbol: string): string => {
  if (!symbol || typeof symbol !== 'string') return '';
  let result = symbol;
  if (symbol?.includes('/USD')) {
    result = symbol.replace('/', '-');
  }
  return result;
};

export const convertToTickerCardQuote = ({
  cryptoQuote,
  stockQuote,
}: UseTickerDataResult): TickerCardQuote | undefined => {
  if (stockQuote || cryptoQuote) {
    return {
      bzExchange: stockQuote?.bzExchange,
      change: (cryptoQuote?.change ?? stockQuote?.change) as number,
      changePercent: (cryptoQuote?.changePercent ?? stockQuote?.changePercent) as number,
      dayHigh: (cryptoQuote?.dayHigh ?? stockQuote?.high) as number,
      dayLow: (cryptoQuote?.dayLow ?? stockQuote?.low) as number,
      fiftyTwoWeekHigh: stockQuote?.fiftyTwoWeekHigh,
      fiftyTwoWeekLow: stockQuote?.fiftyTwoWeekLow,
      marketCap: cryptoQuote?.marketCap ? Number(cryptoQuote?.marketCap) : undefined,
      name: (cryptoQuote?.name ?? stockQuote?.name) as string,
      price: (stockQuote?.lastTradePrice ?? cryptoQuote?.price) as number,
      symbol: (cryptoQuote?.symbol ?? stockQuote?.symbol) as string,
      volume: (cryptoQuote?.volume ?? stockQuote?.volume) as number,
    };
  } else {
    return undefined;
  }
};
